export default "__VITE_ASSET__DfJaTzjw__"